<template>
    <div>
        <section class="fw-section margin-top-3x" :style="{ backgroundImage: bgUrl }">
        <h1 class="display-404 text-center">404</h1>
        </section>
        <div class="container padding-bottom-3x mb-1">
        <div class="text-center">
            <h2>Page Not Found</h2>
            <p>It seems we can’t find the page you are looking for. <router-link to="/">Go back to Homepage</router-link><br>Or try using search at the top right corner of the page.</p>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Error404Component',
    data(){
        return{
            bgUrl:''
        }
    },
    created(){
        this.bgUrl = 'url('+this.dukaURL+'assets/img/404-bg.png)'
    }
}
</script>